var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sub-cat-view"}},[_c('g-subcat-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }